import { Helmet } from "react-helmet";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Container,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import Search from "@mui/icons-material/Search";
import InboxLayout from "../../../components/inbox/InboxLayout";
import cssVariables from "../../../theme/cssVariables";

const useStyles = makeStyles({
  media: {
    height: 200,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  blueBg: {
    background: "#6694CC",
  },
  purpleBg: {
    background: "#7580BD",
  },
  customCardSize: {
    height: 380,
  },
  cardContentSize: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    alignItems: "center",
    height: "calc(100% - 130px)",
  },
	toggleBtnRoot: {
    background: `#fff!important`,
    color: "#C2C2C2!important",
		width: "120px"
  },
  toggleBtnSelected: {
    background: `${cssVariables.color.primary}!important`,
    color: "#fff!important",
  },
	searchBar: {
		height: "48px!important",
	},
	".searchBar": {
		height: "48px!important",
	}
});
const Inbox = () => {
  const { t } = useTranslation();
  const [inboxType, setInboxType] = React.useState("received");
  const handleButtonGroup = (_, value) => {
    if(value) setInboxType(value);
  };
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Inbox | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container mt={1} mb={1}>
              <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={{color: "#5DA196",cursor: "pointer",}} onClick={() => navigate('/kpi/home')}>{t('label.home')}</span> / <span style={{color: "#A3A3A3"}} >กล่องข้อความ</span></Typography>
          </Grid>
          <Grid container spacing={2} mt={1} mb={2}>
            <Grid item>
              <Typography variant="h2">
                {/* {t("home.label.latestInbox")} */}
								กล่องข้อความ
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1} mb={2}>
            <Grid item xs="auto">
              <Box>
                <ToggleButtonGroup
                  value={inboxType}
                  onChange={handleButtonGroup}
                  aria-label="inbox type"
                  exclusive={true}
                >
                  <ToggleButton
                    value="received"
                    aria-label="centered"
                    classes={{ root: classes.toggleBtnRoot, selected: classes.toggleBtnSelected }}
                  >
                    <Typography>ได้รับ</Typography>
                  </ToggleButton>
                  <ToggleButton
                    value="sent"
                    aria-label="centered"
                    classes={{ root: classes.toggleBtnRoot, selected: classes.toggleBtnSelected }}
                  >
                    <Typography>ที่ส่ง</Typography>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Grid>
          </Grid>
          <InboxLayout selectedInbox={inboxType}/>
        </Container>
      </Box>
    </>
  );
};
export default Inbox;
